<app-http-spinner></app-http-spinner>
<p-toast>
  <ng-template pTemplate="message" let-msg>
    <span class="p-toast-message-icon pi"
      [class.pi-check]="msg?.severity === 'success'"
      [class.pi-times-circle]="msg?.severity === 'error'"
      [class.pi-exclamation-triangle]="msg?.severity === 'warn'"
      [class.pi-info-circle]="msg?.severity === 'info' || !msg?.severity"
    ></span>
    <div class="p-toast-message-text">
      <span class="p-toast-summary">{{ msg?.summary }}</span>
      <div class="p-toast-detail">{{ msg?.detail }}</div>
      @if (msg?.data?.errors?.length) {
        <ul class="notification-error-list">
          @for (err of msg.data.errors; track err) {
            <li>{{ err.description }}</li>
          }
        </ul>
      }
    </div>
  </ng-template>
</p-toast>
<router-outlet />
